document.addEventListener("DOMContentLoaded", function () {
  // The calculator's own ids are suffixed with the section id so two instances on one page
  // (e.g. a Featured Product block on a PDP) cannot collide. Resolve them through el().
  const calculatorRoot = document.querySelector(".calculator-div[data-section-id]");
  const sectionId = calculatorRoot ? calculatorRoot.getAttribute("data-section-id") : "";
  const el = (name) => document.getElementById(sectionId ? name + "-" + sectionId : name);
  const inRoot = (selector) => (calculatorRoot || document).querySelector(selector);

  // Wording comes from the locale file via data attributes rendered onto the calculator root
  // (this is a static asset file, not Liquid, so it cannot call the `t` filter directly).
  // Templates carry a literal "{{ quantity }}" placeholder, substituted in at call time.
  const i18n = {
    totalPacks: (calculatorRoot && calculatorRoot.getAttribute("data-i18n-total-packs")) || "Total Packs: {{ quantity }}",
    qtyRequired: (calculatorRoot && calculatorRoot.getAttribute("data-i18n-qty-required")) || "Qty Required: {{ quantity }} packs",
    vatInc: (calculatorRoot && calculatorRoot.getAttribute("data-i18n-vat-inc")) || " inc VAT",
    vatEx: (calculatorRoot && calculatorRoot.getAttribute("data-i18n-vat-ex")) || " ex VAT",
  };
  function formatQuantity(template, quantity) {
    return template.replace("{{ quantity }}", quantity);
  }

  const totalAreaRadio = el("total-area");
  const widthLengthRadio = el("Width-Length");

  const areaInputContainer = inRoot(".input-container-area");
  const lengthWidthInputsContainer = inRoot(".length-width-inputs");

  function toggleInputFields() {
    if (totalAreaRadio.checked) {
      areaInputContainer.style.display = "block";
      lengthWidthInputsContainer.style.display = "none";
    } else {
      areaInputContainer.style.display = "none";
      lengthWidthInputsContainer.style.display = "flex";
    }
  }

  toggleInputFields();

  totalAreaRadio.addEventListener("change", toggleInputFields);
  widthLengthRadio.addEventListener("change", toggleInputFields);

  let currentUnit = "meters";

  function convertToMeters(value, unit, isArea = false) {
    if (isNaN(value)) return 0;
    const conversions = {
      centimeters: isArea ? value / 10000 : value / 100,
      feet: isArea ? value / 10.764 : value / 3.281,
    };
    return conversions[unit] !== undefined ? conversions[unit] : value;
  }

  // Coverage comes from a single-line-text metafield, so it can be blank or non-numeric.
  // Returning null lets callers bail out rather than dividing by NaN and printing "NaN".
  function getCoverage() {
    if (!calculatorRoot) return null;
    const coverage = parseFloat(calculatorRoot.getAttribute("data-metafield-coverage"));
    return coverage > 0 ? coverage : null;
  }

  // Zero state for the calculate tab. The price must be reset alongside the packs/area text,
  // otherwise a stale total survives clearing the inputs or switching to the packs tab and back.
  // Deliberately does not touch the quantity input: this also runs on initial page load, where
  // the picker should keep its default of 1.
  function resetTotals() {
    el("qty-required").innerHTML = formatQuantity(i18n.totalPacks, 0);
    el("area-required-value").innerHTML = "0";
    window.latestTotalPrice = 0;
    updateCustomPriceDisplay(0);
  }

  function updateLabels() {
    const unitLabels = {
      meters: { width: "(m)", length: "(m)", area: "(m²)" },
      centimeters: { width: "(cm)", length: "(cm)", area: "(cm²)" },
      feet: { width: "(ft)", length: "(ft)", area: "(ft²)" },
    };
    const labels = unitLabels[currentUnit];
    inRoot(".width-input-container .floating-input-label").innerHTML = labels.width;
    inRoot(".length-input-container .floating-input-label").innerHTML = labels.length;
    inRoot(".input-container-area .floating-input-label").innerHTML = labels.area;
  }

  // Prices held in data attributes are inc VAT. The VAT toggle (assets/vat-toggle.js) calls this
  // back with window.latestTotalPrice, so every price write must go through here to stay in sync.
  window.updateCustomPriceDisplay = function (totalPrice) {
    if (typeof totalPrice !== "number" || isNaN(totalPrice)) return;
    const priceDisplay = el("total-price-display");
    const btnPriceDisplay = document.getElementById("button-dynamic-pricing");
    const vatCurrent = sessionStorage.getItem("vatToggle");
    const includeVAT = vatCurrent === "true";
    const displayPrice = includeVAT ? totalPrice : totalPrice / 1.2;
    const vatMessage = includeVAT ? i18n.vatInc : i18n.vatEx;
    if (priceDisplay) {
      priceDisplay.innerHTML = `£${displayPrice.toFixed(2)}` + `<span class="vat-message">${vatMessage}</span>`;
    }
    if (btnPriceDisplay) {
      btnPriceDisplay.innerHTML = `£${displayPrice.toFixed(2)}` + vatMessage;
    }
  };

  // Function to update price based on quantity selector
  function updatePriceFromQuantitySelector() {
    try {
      const calculatorDiv = calculatorRoot;
      if (!calculatorDiv) return;

      const sectionId = calculatorDiv.getAttribute("data-section-id");
      const quantityPicker = calculatorRoot.querySelector(`.price-per-item__container #Quantity-${sectionId}`);

      if (quantityPicker) {
        const quantity = parseInt(quantityPicker.value) || 0;
        const perPackPrice = parseFloat(calculatorDiv.getAttribute('data-per-pack-price')) || 0;
        const totalPrice = quantity * perPackPrice;

        // Update the Total Packs and m² display fields
        const qtyRequired = el("qty-required");
        const areaRequiredValue = el("area-required-value");
        const coverage = getCoverage();

        if (qtyRequired) {
          qtyRequired.innerHTML = formatQuantity(i18n.totalPacks, quantity);
        }
        if (areaRequiredValue) {
          // Without a usable coverage value the area is unknowable — show 0 rather than
          // falling back to 1m² per pack, which would look plausible but be wrong.
          areaRequiredValue.innerHTML = coverage === null ? "0" : (quantity * coverage).toFixed(2);
        }

        window.latestTotalPrice = totalPrice;
        updateCustomPriceDisplay(totalPrice);
      }
    } catch (error) {
      console.warn('Error updating price from quantity selector:', error);
    }
  }

  // Function to update quantity selector from calculator
  function updateQuantitySelector(quantity) {
    const calculatorDiv = calculatorRoot;
    if (!calculatorDiv) return;

    const sectionId = calculatorDiv.getAttribute("data-section-id");
    const quantityPicker = calculatorRoot.querySelector(`.price-per-item__container #Quantity-${sectionId}`);

    if (quantityPicker) {
      quantityPicker.value = quantity;
      quantityPicker.setAttribute("value", quantity);
      // Trigger any quantity-related events
      quantityPicker.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  function calculateQuantityLengthWidth() {
    const width = parseFloat(el("calculator-width").value);
    const length = parseFloat(el("calculator-length").value);
    const addWastage = el("add-wastage").checked;

    const coverage = getCoverage();

    if (isNaN(width) || isNaN(length) || coverage === null) {
      resetTotals();
      updateQuantitySelector(0);
      return;
    }

    let convertedWidth = convertToMeters(width, currentUnit);
    let convertedLength = convertToMeters(length, currentUnit);
    let output = convertedWidth * convertedLength;
    if (addWastage) output *= 1.05;

    let areaOutput = output.toFixed(2);
    output = Math.ceil(output / coverage);

    el("qty-required").innerHTML = formatQuantity(i18n.qtyRequired, output);
    el("area-required-value").innerHTML = areaOutput;

    updateQuantitySelector(output);

    const perPackPrice = parseFloat(calculatorRoot.getAttribute('data-per-pack-price')) || 0;
    const totalPrice = output * perPackPrice;

    window.latestTotalPrice = totalPrice;
    updateCustomPriceDisplay(totalPrice);
  }

  function calculateQuantityArea() {
    const area = parseFloat(el("calculator-area").value);
    const addWastage = el("add-wastage").checked;

    const coverage = getCoverage();

    if (isNaN(area) || coverage === null) {
      resetTotals();
      updateQuantitySelector(0);
      return;
    }

    let output = convertToMeters(area, currentUnit, true);
    if (addWastage) output *= 1.05;

    let areaOutput = output.toFixed(2);
    output = Math.ceil(output / coverage);

    el("qty-required").innerHTML = formatQuantity(i18n.totalPacks, output);
    el("area-required-value").innerHTML = areaOutput;

    updateQuantitySelector(output);

    const perPackPrice = parseFloat(calculatorRoot.getAttribute('data-per-pack-price')) || 0;
    const totalPrice = output * perPackPrice;

    window.latestTotalPrice = totalPrice;
    updateCustomPriceDisplay(totalPrice);
  }

  function wastage() {
    const width = parseFloat(el("calculator-width").value);
    const length = parseFloat(el("calculator-length").value);
    const area = parseFloat(el("calculator-area").value);

    if (!isNaN(width) || !isNaN(length)) {
      el("calculator-area").value = "";
      calculateQuantityLengthWidth();
    } else if (!isNaN(area)) {
      el("calculator-width").value = "";
      el("calculator-length").value = "";
      calculateQuantityArea();
    } else {
      resetTotals();
    }
  }

  // Called by the tab switcher when returning to the calculate tab, so the totals reflect the
  // calculator inputs rather than whatever the packs tab last displayed.
  window.recalculateCalculatorTotals = wastage;

  function wastageLengthWidth() {
    const width = parseFloat(el("calculator-width").value);
    const length = parseFloat(el("calculator-length").value);
    if (!isNaN(width) || !isNaN(length)) {
      el("calculator-area").value = "";
      calculateQuantityLengthWidth();
    } else {
      resetTotals();
    }
  }

  function wastageArea() {
    const area = parseFloat(el("calculator-area").value);
    if (!isNaN(area)) {
      el("calculator-width").value = "";
      el("calculator-length").value = "";
      calculateQuantityArea();
    }
  }

  const unitRadios = (calculatorRoot || document).querySelectorAll('input[name^="measurement-unit"]');

  function updateUnit() {
    const selectedUnit = inRoot("input[name^='measurement-unit']:checked");
    if (selectedUnit) {
      currentUnit = selectedUnit.value;
      updateLabels();
      wastage();
    }
  }

  unitRadios.forEach((radio) => {
    radio.addEventListener("change", updateUnit);
  });

  updateUnit();

  el("calculator-width").addEventListener("input", wastageLengthWidth);
  el("calculator-length").addEventListener("input", wastageLengthWidth);
  el("calculator-area").addEventListener("input", wastageArea);
  el("add-wastage").addEventListener("change", wastage);

  // Add event listeners for quantity selector
  function setupQuantitySelectorListeners() {
    const calculatorDiv = calculatorRoot;
    if (!calculatorDiv) return;

    const sectionId = calculatorDiv.getAttribute("data-section-id");
    const quantityPicker = calculatorRoot.querySelector(`.price-per-item__container #Quantity-${sectionId}`);

    if (quantityPicker) {
      // Listen for direct input changes
      quantityPicker.addEventListener("input", updatePriceFromQuantitySelector);
      quantityPicker.addEventListener("change", updatePriceFromQuantitySelector);

      // Don't add duplicate click listeners to plus/minus buttons
      // The QuantityInput class already handles these
      // Instead, listen for the change event that gets dispatched
    }
  }

  // Setup quantity selector listeners on load
  setupQuantitySelectorListeners();

  // Optimized MutationObserver with error handling
  let observer = null;
  try {
    observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        if (mutation.type === 'childList') {
          // Debounce the setup to prevent excessive calls
          clearTimeout(window.quantitySetupTimeout);
          window.quantitySetupTimeout = setTimeout(setupQuantitySelectorListeners, 100);
        }
      });
    });

    // Observe the calculator div for changes
    const calculatorDiv = calculatorRoot;
    if (calculatorDiv) {
      observer.observe(calculatorDiv, { childList: true, subtree: true });
    }
  } catch (error) {
    console.warn('MutationObserver setup failed:', error);
  }

  // Function to reset price display after cart update
  function resetPriceDisplay() {
    // Check which tab is currently active
    const calculatorHeaderButton = el("calculator-header-button");
    const packsHeaderButton = el("packs-header-button");
    const isCalculatorTabActive = calculatorHeaderButton?.classList.contains('active');
    const isPacksTabActive = packsHeaderButton?.classList.contains('active');

    // If packs tab is active, don't reset quantity and price
    if (isPacksTabActive) {
      // Only reset calculator fields, keep quantity selector and price
      const areaInput = el("calculator-area");
      const widthInput = el("calculator-width");
      const lengthInput = el("calculator-length");
      const wastageCheckbox = el("add-wastage");
      const qtyRequired = el("qty-required");
      const areaRequiredValue = el("area-required-value");

      // Reset only calculator input fields
      if (areaInput) {
        areaInput.value = "";
      }
      if (widthInput) {
        widthInput.value = "";
      }
      if (lengthInput) {
        lengthInput.value = "";
      }
      if (wastageCheckbox) {
        wastageCheckbox.checked = false;
      }

      // Reset only calculator display fields
      if (qtyRequired) {
        qtyRequired.innerHTML = formatQuantity(i18n.totalPacks, 0);
      }
      if (areaRequiredValue) {
        areaRequiredValue.innerHTML = "0";
      }

      // Reset price to price of 1 item
      const calculatorDiv = calculatorRoot;
      if (calculatorDiv) {
        const perPackPrice = parseFloat(calculatorDiv.getAttribute('data-per-pack-price')) || 0;

        // Update the latest total price to price of 1 item
        window.latestTotalPrice = perPackPrice;
        updateCustomPriceDisplay(perPackPrice);
      }

      // Keep quantity selector as it is
      return;
    }

    // If calculator tab is active, reset everything
    window.latestTotalPrice = 0;
    updateCustomPriceDisplay(0);

    // Reset all calculation fields
    const areaInput = el("calculator-area");
    const widthInput = el("calculator-width");
    const lengthInput = el("calculator-length");
    const wastageCheckbox = el("add-wastage");
    const qtyRequired = el("qty-required");
    const areaRequiredValue = el("area-required-value");

    // Reset input fields
    if (areaInput) {
      areaInput.value = "";
    }
    if (widthInput) {
      widthInput.value = "";
    }
    if (lengthInput) {
      lengthInput.value = "";
    }
    if (wastageCheckbox) {
      wastageCheckbox.checked = false;
    }

    // Reset display fields
    if (qtyRequired) {
      qtyRequired.innerHTML = formatQuantity(i18n.totalPacks, 0);
    }
    if (areaRequiredValue) {
      areaRequiredValue.innerHTML = "0";
    }

    // Reset quantity selector to default (1)
    const calculatorDiv = calculatorRoot;
    if (calculatorDiv) {
      const sectionId = calculatorDiv.getAttribute("data-section-id");
      const quantityPicker = calculatorRoot.querySelector(`.price-per-item__container #Quantity-${sectionId}`);
      if (quantityPicker) {
        quantityPicker.value = 1;
        quantityPicker.setAttribute("value", 1);
      }
    }
  }

  // Listen for cart update events to reset price
  document.addEventListener('cart:updated', resetPriceDisplay);
  document.addEventListener('cart:refresh', resetPriceDisplay);

  // Also listen for form submission to reset price
  function setupAddToCartListeners() {
    const addToCartButtons = document.querySelectorAll('[id^="ProductSubmitButton-"]');
    addToCartButtons.forEach(button => {
      button.addEventListener('click', function () {
        // Reset price after a short delay to allow cart update
        setTimeout(resetPriceDisplay, 1000);
      });
    });
  }

  // Setup add to cart listeners on load
  setupAddToCartListeners();

  // Optimized cart observer with error handling
  let cartObserver = null;
  try {
    cartObserver = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        if (mutation.type === 'childList') {
          // Debounce the setup to prevent excessive calls
          clearTimeout(window.cartSetupTimeout);
          window.cartSetupTimeout = setTimeout(setupAddToCartListeners, 100);
        }
      });
    });

    // Observe the document body for changes (more targeted)
    cartObserver.observe(document.body, { childList: true, subtree: false });
  } catch (error) {
    console.warn('Cart MutationObserver setup failed:', error);
  }

  // Cleanup function for observers
  function cleanup() {
    if (observer) {
      observer.disconnect();
    }
    if (cartObserver) {
      cartObserver.disconnect();
    }
    clearTimeout(window.quantitySetupTimeout);
    clearTimeout(window.cartSetupTimeout);
  }

  // Cleanup on page unload
  window.addEventListener('beforeunload', cleanup);

  updateLabels();
});
